module.exports = __webpack_public_path__ + "img/categoryInfo.006c0890.png";